import RingLoader from '@jetbrains/ring-ui-built/components/loader/loader'

function Loader(props: {className?: string}) {
  return <RingLoader {...props} squares />
}

export default Loader
